import ReactModal from "react-modal";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { PrimaryButton, SecondaryButton } from "../../Button";
import { HeadLine } from "../../HeadLine";

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CloseTxt = styled.p`
  line-height: 1.88;
  font-size: 14px;
`;

const ConfirmCloseModal = ({ doClose, isOpen, doDelete }) => {
  return (
    <ReactModal
      className="Modal__Bootstrap modal-dialog"
      onRequestClose={() => {
        doClose();
      }}
      isOpen={isOpen}
    >
      <div className="modal-content modal-content-padding">
        <div className="modal-header mar-t-5">
          <HeadLine headingText="Attention!" />
          <div className="acct-modal-hr"></div>
        </div>
        <div
          className="modal-body modal-body-padding"
          style={{ fontSize: "14px" }}
        >
          <CloseTxt>
            Are you sure want to delete this card from the cart?
          </CloseTxt>
          <CloseTxt>
            Deleting this card removes it from your cart completely, and cannot
            be recovered.
          </CloseTxt>
          <br />
          <div className="modal-input-mar-b-20">
            <div className="modal-input-flex-2-pad-r-10">
              <Actions>
                <PrimaryButton
                  style={{ height: "50px" }}
                  onClick={() => {
                    doDelete();
                    doClose();
                  }}
                >
                  YES
                </PrimaryButton>
                &nbsp;&nbsp;
                <SecondaryButton
                  style={{ height: "50px" }}
                  onClick={() => doClose()}
                >
                  NO
                </SecondaryButton>
              </Actions>
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

ConfirmCloseModal.propTypes = {
  doClose: PropTypes.func.isRequired,
  doDelete: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export { ConfirmCloseModal };
